<script>

    export let icon = 'far fa-chart-bar'
    export let title = ''
    export let value = 0
    export let change = 0
    export let sparkline = []
    export let compare = 'vs periodo anterior'
    export let changeSuffix = '%'

    const WIDTH = 96
    const HEIGHT = 44
    const PAD = 4
    const ACCENT = '#22c55e'
    const fillId = `stats-fill-${Math.random().toString(36).slice(2, 8)}`

    $: isUp = change >= 0
    $: chart = buildSparkline(sparkline)

    function buildSparkline(values) {
        if (!values.length)
            return { line: '', area: '' }

        const min = Math.min(...values)
        const max = Math.max(...values)
        const range = max - min || 1

        const points = values.map((v, i) => {
            const x = values.length === 1 ? WIDTH / 2 : (i / (values.length - 1)) * WIDTH
            const y = PAD + (1 - (v - min) / range) * (HEIGHT - PAD * 2)
            return { x, y }
        })

        const line = points.map((p, i) => `${i ? 'L' : 'M'}${p.x},${p.y}`).join(' ')
        const last = points[points.length - 1]
        const area = `${line} L${last.x},${HEIGHT} L${points[0].x},${HEIGHT} Z`

        return { line, area }
    }

</script>

<style>
    .stats-card {
        --accent: #22c55e;
        --accent-soft: #e8f8ef;
        --text: #1a1a1a;
        --muted: #9e9e9e;

        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
        padding: 1.2rem 1.25rem;
        height: 100%;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 0.9rem;
    }

    .header {
        display: flex;
        align-items: center;
        gap: 0.55rem;
        min-width: 0;
    }

    .icon {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: var(--accent-soft);
        color: var(--accent);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.78rem;
        flex-shrink: 0;
    }

    .title {
        font-size: 0.9rem;
        font-weight: 600;
        color: var(--text);
        margin: 0;
        line-height: 1.2;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .body {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        gap: 0.75rem;
        min-width: 0;
        flex: 1;
    }

    .metrics {
        min-width: 0;
        flex: 1 1 auto;
    }

    .value {
        font-size: 1.9rem;
        font-weight: 700;
        color: var(--text);
        line-height: 1;
        margin: 0 0 0.45rem;
        letter-spacing: -0.02em;
    }

    .trend {
        display: flex;
        align-items: baseline;
        flex-wrap: wrap;
        gap: 0.3rem;
        font-size: 0.8rem;
        line-height: 1.2;
    }

    .change {
        display: inline-flex;
        align-items: center;
        gap: 0.2rem;
        font-weight: 600;
        color: var(--accent);
        white-space: nowrap;
    }

    .change.is-down {
        color: #ef4444;
    }

    .change :global(i) {
        font-size: 0.65rem;
    }

    .compare {
        color: var(--muted);
        font-weight: 400;
        white-space: nowrap;
    }

    .sparkline {
        width: 96px;
        height: 44px;
        flex: 0 0 96px;
    }
</style>

<div class="stats-card">
    <div class="header">
        {#if icon}
            <div class="icon">
                <i class={icon}></i>
            </div>
        {/if}
        <h3 class="title">{ title }</h3>
    </div>

    <div class="body">
        <div class="metrics">
            <p class="value">{ value }</p>
            {#if change != null}
                <div class="trend">
                    <span class="change" class:is-down={!isUp}>
                        <i class="fas {isUp ? 'fa-arrow-up' : 'fa-arrow-down'}"></i>
                        { Math.abs(change) }{ changeSuffix }
                    </span>
                    {#if compare}
                        <span class="compare">{ compare }</span>
                    {/if}
                </div>
            {/if}
        </div>

        {#if chart.line}
            <svg class="sparkline" viewBox="0 0 {WIDTH} {HEIGHT}" aria-hidden="true">
                <defs>
                    <linearGradient id={fillId} x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stop-color={ACCENT} stop-opacity="0.2" />
                        <stop offset="100%" stop-color={ACCENT} stop-opacity="0" />
                    </linearGradient>
                </defs>
                <path d={chart.area} fill={"url(#" + fillId + ")"} />
                <path d={chart.line} fill="none" stroke={ACCENT} stroke-width="2" stroke-linejoin="round" stroke-linecap="round" />
            </svg>
        {/if}
    </div>
</div>
